module.exports = __webpack_public_path__ + "static/media/detail8.b705e8cb.jpg";